import tinymce from "tinymce";
import 'tinymce/icons/default';

import 'tinymce/themes/silver';
import 'tinymce/skins/ui/oxide/skin.css';

import 'tinymce/plugins/advlist';
import 'tinymce/plugins/code';
import 'tinymce/plugins/link';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/autoresize';
import 'tinymce/plugins/table';
import 'tinymce/plugins/fullscreen';
import { AddPjaxUnmountListener } from "./Pjax";

import { cast } from './tools.js'

import 'tinymce/models/dom';

export function render(element: HTMLElement) {
    const previousEditor = tinymce.get(element.id);
    if (previousEditor != null) {
        console.log("suspicious existing TinyMCE " + element.id, previousEditor);
        tinymce.remove(previousEditor);
    }

    const editorPromise = tinymce.init({
        id: element.id,
        target: element,
        menubar: false,
        
        //TinyMCE zet implciet de browser-spellcheck uit; als we die aan willen zetten is zoiets geen gek idee
        //browser_spellcheck: true, 
        //contextmenu : false, //maar de browser-spellcheck werkt alleen echt goed met context-menu

        width: 800, // in sync houden met tinymce.css width: 800px hack
        plugins: 'table lists link code autoresize',
        autoresize_overflow_padding: 5,
        autoresize_bottom_margin: 5,
        height: 10,
        statusbar: false,
        elementpath: false,
        toolbar: 'bold italic underline superscript subscript removeformat | numlist bullist blockquote | link unlink | table | blocks | undo redo | code',
        content_style: 
            `
                body {
                    font-family: Verdana, Arial, sans-serif, "Trebuchet MS", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
                    font-size: 12px;
                }
            `
        ,
        paste_webkit_styles: 'all',
        content_css: false,
        skin: false,
        paste_data_images: false,
        table_advtab: false,
        formats: {
            underline: { inline: 'u', exact: true, }
        },
        branding: false,
        convert_unsafe_embeds: true, // fix security/dependabot/9 without requiring gpl 2.0 tinymce v7
        paste_preprocess: function (plugin, args) {
            const content = new DOMParser().parseFromString(args.content, "text/html");

            let result = traverseAndWrap(content.body);
            content.body.innerHTML = '';
            content.body.replaceWith(result);
            args.content = content.body.innerHTML;
        },
    });
    AddPjaxUnmountListener(() => editorPromise.then(editors => editors.forEach(editor => editor.remove())));
};

function traverseAndWrap(element: Node) {

    if (!(element instanceof HTMLElement)) {
        return element.cloneNode(false);
    }

    const cleanedChildren = document.createDocumentFragment();
    for (const child of element.childNodes) {
        cleanedChildren.appendChild(traverseAndWrap(child));
    }
    let cleanedContent = cast(cleanedChildren, Node);

    cleanedContent = wrapItalicElements(element, cleanedContent);
    cleanedContent = wrapUnderlineElements(element, cleanedContent);
    cleanedContent = wrapBoldElements(element, cleanedContent);

    if (!(element.tagName === 'B' && element.style.fontWeight === 'normal' || element.tagName === 'SPAN')) {
        let cloned = cast(element.cloneNode(false), HTMLElement);
        cloned.removeAttribute('style');
        cloned.append(cleanedContent);
        cleanedContent = cloned;
    }

    return cleanedContent;
}

function wrapItalicElements(element: HTMLElement, cleanedContent: Node) {

    if (element.style.fontStyle === 'italic') {
        const italicElement = document.createElement('em');
        italicElement.append(cleanedContent);
        return italicElement;
    } else {
        return cleanedContent;
    }
}

function wrapUnderlineElements(element: HTMLElement, cleanedContent: Node) {
    if (element.style.textDecoration === 'underline') {
        const underlineElement = document.createElement('u');
        underlineElement.append(cleanedContent);
        return underlineElement
    } else {
        return cleanedContent;
    }
}
function wrapBoldElements(element: HTMLElement, cleanedContent: Node) {
    if (element.style.fontWeight == '700' || element.style.fontWeight === 'bold') {
        const boldElement = document.createElement('b');
        boldElement.append(cleanedContent);
        return boldElement;
    } else {
        return cleanedContent;
    }
}
